import React, { Component } from "react";
import { connect } from "react-redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import UserListTable from "./UserListTable";

class UsersView extends Component {
  state = {};
  render() {
    const prevPath = "settings",
      currentPage = "/users";
    return (
      <div className="ticket-body">
        <TabHeaderAndButton
          header="Users"
          path={`/${prevPath}${currentPage}/create`}
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}
          btnLabel="New user"
        />
        <div>
          <UserListTable location={`${prevPath}${currentPage}/edit`} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    MainFarmId: state.FarmManagementReducer.MainFarmId
  }
}

export default connect(
  mapStateToProps
)(UsersView);



// WEBPACK FOOTER //
// ./src/components/private/Users/UsersView.js